export const vaellukset = [
  {
    name: 'aloittelijoiden-vaellus-hetta-pallas-2027',
    title: 'Aloittelijoiden vaellus Hetta-Pallas 2027',
    dates: ['17-20.6.2027', '16-19.9.2027'],
    link: '/vaellukset/aloittelijoiden-vaellus-hetta-pallas-2027',
  },
];

export const hiihtovaellukset = [
  {
    name: 'kaamoshiihto-pallas-yllastunturin-kansallispuistossa',
    title: 'Kaamoshiihto Pallas-Yllästunturin kansallispuistossa',
    dates: ['4.-6.12.2026'],
    link: '/hiihtovaellukset/kaamoshiihto-pallas-yllastunturin-kansallispuistossa',
  },
  {
    name: 'aloittelijoiden-hetta-pallas-hiihtovaellus',
    title: 'Aloittelijoiden Hetta-Pallas Hiihtovaellus',
    dates: ['10.-14.3.2027'],
    link: '/hiihtovaellukset/aloittelijoiden-hetta-pallas-hiihtovaellus',
  },
];

export const maastopyoraily = [];

export const vapaalasku = [
  {
    name: 'kilpisjärven-vapaalaskuviikonloppu',
    title: 'Kilpisjärven vapaalaskuviikonloppu',
    dates: ['24.-26.4.2025'],
    link: '/vapaalasku/kilpisjärven-vapaalaskuviikonloppu',
  },
];

export const verkkokurssit = [
  {
    name: 'talviretkeilyn-turvallisuus',
    title: 'Talviretkeilyn turvallisuus',
    dates: ['25.1.2025 klo 18.30-20.30', '10.2.2025 klo 18.30-20.30'],
    link: '/verkkokurssit/talviretkeilyn-turvallisuus',
  },
];
